import { AdvertiseThankYou } from '@/components/advertise/AdvertiseThankYou';
import { ADVERTISE_AGENTS } from '@/constants/testIds/advertise';

export default function AgentsThankYou() {
  return (
    <AdvertiseThankYou
      testId={ADVERTISE_AGENTS.thankYouHeading}
      heading="Request received!"
      subtitle="A member of our advertising team will reach out within 1 business day to get your listings boosted."
      secondaryLinks={[
        { to: '/', label: 'Back to casahom', variant: 'outline' },
        { to: '/dashboard/my-listings', label: 'Go to my listings' },
      ]}
    />
  );
}
